import caJson from '../translations/ca/ca.json'
import enJson from '../translations/en/en.json'
import esJson from '../translations/es/es.json'
import modal_caJson from '../translations/ca/modal_ca.json'
import modal_enJson from '../translations/en/modal_en.json'
import modal_esJson from '../translations/es/modal_es.json'
import organitzacions_caJson from '../translations/ca/organitzacions_ca.json'
import organitzacions_enJson from '../translations/en/organitzacions_en.json'
import organitzacions_esJson from '../translations/es/organitzacions_es.json'
import titulacions_caJson from '../translations/ca/titulacions_ca.json'
import titulacions_enJson from '../translations/en/titulacions_en.json'
import titulacions_esJson from '../translations/es/titulacions_es.json'
import assignatures_caJson from '../translations/ca/assignatures_ca.json'
import assignatures_enJson from '../translations/en/assignatures_en.json'
import assignatures_esJson from '../translations/es/assignatures_es.json'
import campus_caJson from '../translations/ca/campus_ca.json'
import campus_enJson from '../translations/en/campus_en.json'
import campus_esJson from '../translations/es/campus_es.json'
import grups_caJson from '../translations/ca/grups_ca.json'
import grups_enJson from '../translations/en/grups_en.json'
import grups_esJson from '../translations/es/grups_es.json'
import publish_caJson from '../translations/ca/publish_ca.json'
import publish_enJson from '../translations/en/publish_en.json'
import publish_esJson from '../translations/es/publish_es.json'
import news_caJson from '../translations/ca/news_ca.json'
import news_enJson from '../translations/en/news_en.json'
import news_esJson from '../translations/es/news_es.json'
import about_caJson from '../translations/ca/about_ca.json'
import about_enJson from '../translations/en/about_en.json'
import about_esJson from '../translations/es/about_es.json'
import { createI18n } from 'vue-i18n'

let appTranslations = {
    ca: { ...caJson, ...modal_caJson, ...organitzacions_caJson, ...titulacions_caJson, ...assignatures_caJson, ...campus_caJson, ...grups_caJson, ...publish_caJson, ...news_caJson, ...about_caJson },
    en: { ...enJson, ...modal_enJson, ...organitzacions_enJson, ...titulacions_enJson, ...assignatures_enJson, ...campus_enJson, ...grups_enJson, ...publish_enJson, ...news_enJson, ...about_enJson },
    es: { ...esJson, ...modal_esJson, ...organitzacions_esJson, ...titulacions_esJson, ...assignatures_esJson, ...campus_esJson, ...grups_esJson, ...publish_esJson, ...news_esJson, ...about_esJson }
}

const allTranslations = appTranslations;

const navigatorLanguage = navigator.language.split('-')[0];

const i18n = createI18n({
    legacy: false,
    locale: navigatorLanguage in allTranslations ? navigatorLanguage : 'en',
    fallbackLocale: 'en',
    messages: allTranslations,
})

export default i18n;
